var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    stroke: "black",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 8.59375H4.6875C4.25603 8.59375 3.90625 8.94353 3.90625 9.375V20.3125C3.90625 20.744 4.25603 21.0938 4.6875 21.0938H20.3125C20.744 21.0938 21.0938 20.744 21.0938 20.3125V9.375C21.0938 8.94353 20.744 8.59375 20.3125 8.59375Z",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98438 8.59375V5.07812C8.98438 4.14572 9.35477 3.25151 10.0141 2.5922C10.6734 1.9329 11.5676 1.5625 12.5 1.5625C13.4324 1.5625 14.3266 1.9329 14.9859 2.5922C15.6452 3.25151 16.0156 4.14572 16.0156 5.07812V8.59375",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.625C12.9315 15.625 13.2812 15.2752 13.2812 14.8438C13.2812 14.4123 12.9315 14.0625 12.5 14.0625C12.0685 14.0625 11.7188 14.4123 11.7188 14.8438C11.7188 15.2752 12.0685 15.625 12.5 15.625Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.fcb4eefb3fbf58bcb9f65b4cb320bef3.svg";
export { ForwardRef as ReactComponent };